import React, { useMemo, useRef, useState } from "react";
import { endOfDay, startOfDay } from "date-fns";
import TransactionDateFilter from "../Transaction/components/TransactionDateFilter";
import {
  normalizePayoutDateRange,
  PayoutDateRangeValue,
} from "./payoutDateUtils";

type PayoutDateRangeFilterProps = {
  label?: string;
  displayText?: string;
  displayTextMode?: "initial" | "override";
  className?: string;
  onChange?: (range: PayoutDateRangeValue) => void;
};

function PayoutDateRangeFilter({
  label,
  displayText,
  displayTextMode = "initial",
  className = "",
  onChange,
}: PayoutDateRangeFilterProps) {
  const [dateRangeLabel, setDateRangeLabel] = useState(displayText ?? "Today");
  const [isDateRangeSelected, setIsDateRangeSelected] = useState(false);
  const selectedRangeRef = useRef({
    startDate: startOfDay(new Date(2024, 2, 12)),
    endDate: endOfDay(new Date(2025, 6, 18)),
    key: "selection",
  });
  const [selectedRange, setSelectedRange] = useState({
    startDate: startOfDay(new Date(2024, 2, 12)),
    endDate: endOfDay(new Date(2025, 6, 18)),
    key: "selection",
  });
  const visibleDateLabel = useMemo(() => {
    if (displayTextMode === "override" && displayText) return displayText;
    if (displayText && dateRangeLabel === displayText) return displayText;
    return dateRangeLabel === "Today" ? "Date (Today)" : dateRangeLabel;
  }, [dateRangeLabel, displayText, displayTextMode]);

  const updateSelectedRange = (range: PayoutDateRangeValue) => {
    selectedRangeRef.current = range;
    setSelectedRange(range);
  };

  return (
    <label className={"block min-w-0 max-w-full " + (className || "min-w-[200px]")}>
      {label && (
        <span className="mb-2 block text-xs font-semibold text-[#505E8E]">
          {label}
        </span>
      )}
      <TransactionDateFilter
        type={dateRangeLabel}
        setType={setDateRangeLabel}
        selectedRange={selectedRange}
        setSelectedRange={updateSelectedRange}
        setIsDateRangeIsSelected={setIsDateRangeSelected}
        isDateRangeIsSelected={isDateRangeSelected}
        displayText={visibleDateLabel}
        popoverPlacement="down"
        minWidthClassName="min-w-0"
        refetch={() => onChange?.(normalizePayoutDateRange(selectedRangeRef.current))}
      />
    </label>
  );
}

export default PayoutDateRangeFilter;
